import React, { Component } from 'react';
import PropTypes from 'prop-types';
import { withStyles } from '@material-ui/core/styles';
import Button from '@material-ui/core/Button';
import InputLabel from '@material-ui/core/InputLabel';
import MenuItem from '@material-ui/core/MenuItem';
import Select from '@material-ui/core/Select';
import FormControl from '@material-ui/core/FormControl';
import DiceUtil from '../utils/DiceUtil';
import SpecialFeatures from './SpecialFeatures.json';
import withRoot from '../withRoot';
import SpecialFeaturesResultRenderer from './SpecialFeaturesResultRenderer';

const styles = theme => ({
    root: {
        margin: theme.spacing.unit,
    },
    formControl: {
        margin: theme.spacing.unit,
        minWidth: 120,
    },
});

class SpecialFeaturesRoller extends Component {
    state = {
        resultCount: 1,
        features: null,
    };

    onSelectChange = name => (event) => {
        this.setState({ [name]: event.target.value });
    }

    rollAndAddFeature(featureOptions, features, allowMultipleRerolls) {
        const options = featureOptions.options;
        const roll = DiceUtil.dice(featureOptions.optionRoll);
        for (let i = 0; i < options.length; i++) {
            let contentRow = options[i];
            if (roll <= contentRow.rollMax) {
                if (contentRow.reroll > 0) {
                    const rerolls = allowMultipleRerolls ? contentRow.reroll : 1;
                    for (let j = 0; j < rerolls; j++) {
                        this.rollAndAddFeature(featureOptions, features, false);
                    }
                }
                else {
                    features[features.length] = { title: contentRow.title, description: contentRow.description };
                }
                return;
            }
        }
    }

    getSpecialFeatures() {
        const features = [];
        for (let i = 0; i < SpecialFeatures.values.length; i++) {
            this.rollAndAddFeature(SpecialFeatures.values[i], features, true);
        }
        return features;
    }

    rollContent() {
        const resultCount = this.state.resultCount;

        const results = Array(resultCount);
        for (let i = 0; i < resultCount; i++) {
            results[i] = this.getSpecialFeatures();
        }

        this.setState({ features: results });
    }

    render() {
        const { classes } = this.props;
        return (
            <div className={classes.root}>
                <div>
                    <FormControl className={classes.formControl}>
                        <InputLabel htmlFor="results">Results</InputLabel>
                        <Select value={this.state.resultCount} onChange={this.onSelectChange("resultCount")} inputProps={{ id: 'results' }}>
                            {[1, 4, 6, 8, 10, 12, 20].map((value) => (
                                <MenuItem key={value} value={value}>{value}</MenuItem>
                            ))}
                        </Select>
                    </FormControl>

                    <Button variant="raised" color="primary" onClick={() => this.rollContent()}>Roll Special Features</Button>
                </div>

                <SpecialFeaturesResultRenderer features={this.state.features} />
            </div>
        );
    }
}

SpecialFeaturesRoller.propTypes = {
    classes: PropTypes.object.isRequired,
};

export default withRoot("Special Features", withStyles(styles)(SpecialFeaturesRoller));


// WEBPACK FOOTER //
// ./src/item-helpers/SpecialFeaturesRoller.js